import React from "react";

const InlineLoader = ({ 
  message = "Loading...", 
  minHeight = "min-h-[400px]",
  size = "h-12 w-12",
  className = ""
}) => {
  return (
    <div className={`flex items-center justify-center ${minHeight} ${className}`}>
      <div className="text-center">
        <div className={`animate-spin rounded-full ${size} border-b-2 border-indigo-500 mx-auto mb-4`}></div>
        <p className="text-slate-600 dark:text-slate-400">
          {message}
        </p>
      </div>
    </div>
  );
};

export default InlineLoader;
